import React from 'react';
import './Shimmer.css';

const RestaurantShimmer = () => {
  return (
    <div className="restaurant-shimmer">
      <div className="restaurant-shimmer-image"></div>
      <div className="restaurant-shimmer-content">
        <div className="restaurant-shimmer-name"></div>
        <div className="restaurant-shimmer-rating"></div>
        <div className="restaurant-shimmer-info"></div>
        <div className="restaurant-shimmer-fee"></div>
      </div>
    </div>
  );
};

export default RestaurantShimmer; 